/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import DdsCodeListItem from './DDSCodeListItem';
import { useMemo } from 'react';

type DDSCodeList = {
  list: Array<EventObj>;
  investor?: boolean;
};

const DDSCodeList = (props: DDSCodeList) => {
  const { list, investor = false } = props;

  const sortedList = useMemo(
    () =>
      [...list].sort((first, second) => {
        const firstReportingDate = first.reportingDate;
        const secondReportingDate = second.reportingDate;

        const firstHasReportingDate =
          firstReportingDate !== null && firstReportingDate !== undefined && firstReportingDate !== 0;

        const secondHasReportingDate =
          secondReportingDate !== null && secondReportingDate !== undefined && secondReportingDate !== 0;

        // DDS codes without a reporting month appear first
        if (!firstHasReportingDate && !secondHasReportingDate) {
          return 0;
        }

        if (!firstHasReportingDate) {
          return -1;
        }

        if (!secondHasReportingDate) {
          return 1;
        }

        return firstReportingDate - secondReportingDate;
      }),
    [list],
  );

  return (
    <>
      {sortedList.map(
        (listElem) =>
          listElem.occurance !== '00' &&
          listElem.active && (
            <DdsCodeListItem
              key={`${listElem.occurance}-${listElem.timestamp}`}
              listElem={listElem}
              investor={investor}
            />
          ),
      )}
    </>
  );
};

export default DDSCodeList;
